<template>
  <div>
    <list
      row-key="GoodsId"
      ref="list"
      unit="商品档案"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="false"
      :show-toolbar="false"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
    >
      <template slot="table">
        <el-table-column prop="OrderNo" label="单据编号"/>
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">
            {{row.DocDate.split(" ")[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="单位名称" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="Amount" label="订单金额" />
        <el-table-column prop="ClerkName" label="业务员">
          <template slot-scope="{row}">
            {{row.ClerkName}}
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutStatus" label="出库状态">
          <template slot-scope="{row}">
            <span v-if="row.OutStatus==0">未出库</span>
            <span v-else-if="row.Status==1">部分出库</span>
            <span v-else>已出库</span>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptStatus" label="收款状态">
          <template slot-scope="{row}">
            <span v-if="row.ReceiptStatus==0">未收款</span>
            <span v-else-if="row.ReceiptStatus==1">部分收款</span>
            <span v-else>已收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="WxName" label="完成状态">
          <template slot-scope="{row}">
            <span v-if="row.CompleteStatus==0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="销货单">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">未生成</span>
            <span v-else>已生成</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/purchase/splitCost").default,
      params: {
        // BarCode: "", //条码
        // GoodsCode: "", //编码
        // GoodsName: "", //名称
        // Model: "", //规格型号
        // WholesalePrice: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>